import { Link } from "react-router-dom";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/** Same wording as the FAQ "Who processes my payment?" answer. */
export const PAYMENT_PARTNER_COPY =
  "Payment is completed securely on furnifindusa.com, our order-processing site. You'll see the FurniFindUSA name on the payment page and on your bank statement — your order is still with LoftLoom.";

export const PaymentPartnerNote = () => (
  <p className="text-[11px] text-muted-foreground text-center mt-2">
    Secure payment completes on furnifindusa.com, our fulfilment partner.{" "}
    <Popover>
      <PopoverTrigger className="underline underline-offset-2 hover:text-foreground">Why furnifindusa.com?</PopoverTrigger>
      <PopoverContent className="text-[13px] leading-relaxed text-foreground w-72">
        <p>{PAYMENT_PARTNER_COPY}</p>
        <Link to="/faq" className="inline-block mt-2 text-[12px] underline underline-offset-2 text-muted-foreground hover:text-foreground">
          More in our FAQ
        </Link>
      </PopoverContent>
    </Popover>
  </p>
);
